<template>
  <v-app class="custom__bg mt-1">
    <v-container>
      <v-row>
        <!-- Chat List Sidebar -->
        <v-col cols="12" md="4" lg="3" class="mx-0">
          <v-card class="mb-3 premium-card">
            <v-card-text class="pa-3">
              <v-btn
                rounded
                block
                @click="group"
                height="44"
                class="white--text text-capitalize hover-scale"
                color="#f69227"
                elevation="2"
              >
                <v-icon left small>mdi-plus-circle</v-icon>
                Create Group
              </v-btn>
            </v-card-text>
          </v-card>
          
          <v-card
            elevation="2"
            class="premium-card overflow-hidden d-flex flex-column"
            style="height: 520px"
          >
            <div class="pa-3 bg-light">
              <v-text-field
                dense outlined rounded hide-details
                placeholder="Search chats..."
                prepend-inner-icon="mdi-magnify"
                color="#f69227"
              ></v-text-field>
            </div>
            <v-divider></v-divider>
            
            <div class="custom__overflow flex-grow-1">
              <v-list class="pa-0">
                <v-list-item-group v-model="activeChat" active-class="orange--text text--darken-1 bg-light">
                  <template v-for="(item, index) in chats">
                    <v-list-item :key="`chat${index}`" :value="item.id" class="px-3 py-1">
                      <v-list-item-avatar class="my-2">
                        <v-avatar size="42">
                          <img :src="item.avatar" alt="avatar" />
                        </v-avatar>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title style="font-size: 14px; font-weight: 600">{{ item.title }}</v-list-item-title>
                        <v-list-item-subtitle style="font-size: 12px" class="grey--text text--darken-1">{{ item.subtitle }}</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action v-if="item.unread > 0">
                        <v-badge color="#f69227" :content="item.unread"></v-badge>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider :key="'div-'+index" v-if="index < chats.length - 1"></v-divider>
                  </template>
                </v-list-item-group>
              </v-list>
            </div>
          </v-card>
        </v-col>

        <!-- Main Chat Area -->
        <v-col cols="12" md="8" lg="9" class="flex-grow-1 mx-0">
          <v-card class="premium-card d-flex flex-column" style="height: 600px">
            <!-- Chat Header -->
            <v-toolbar flat class="bg-light px-2 flex-shrink-0" height="70">
              <v-list class="pa-0 ma-0 bg-transparent">
                <v-list-item class="px-0">
                  <v-list-item-avatar size="45">
                    <v-avatar size="45">
                      <img :src="activeChatData.avatar" alt="avatar" />
                    </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title style="font-size: 16px; font-weight: 700; color: #333">
                      {{ activeChatData.title }}
                    </v-list-item-title>
                    <v-list-item-subtitle style="font-size: 13px">
                      {{ activeChatData.subtitle }} &bull; <span class="green--text">14 online</span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-spacer></v-spacer>
              <v-btn icon color="grey darken-1" class="hover-scale"><v-icon>mdi-magnify</v-icon></v-btn>
              <v-btn icon color="grey darken-1" class="hover-scale"><v-icon>mdi-dots-vertical</v-icon></v-btn>
            </v-toolbar>
            
            <v-divider></v-divider>

            <!-- Chat Messages -->
            <div class="custom__chat_area flex-grow-1 pa-4 overflow-y-auto" id="chat-container">
              <!-- Date Separator -->
              <div class="d-flex justify-center my-3">
                <v-chip small color="rgba(0,0,0,0.5)" text-color="white" style="font-size: 11px">Today</v-chip>
              </div>

              <!-- Messages Loop -->
              <div v-for="(message, i) in messages" :key="i" class="mb-4">
                <!-- Received Message -->
                <div v-if="!message.isMe" class="d-flex align-start">
                  <v-avatar size="32" class="mr-2 mt-1">
                    <img :src="message.avatar" alt="user" />
                  </v-avatar>
                  <div style="max-width: 75%">
                    <div class="d-flex align-end mb-1">
                      <span class="font-weight-bold" style="font-size: 13px; color: #333">{{ message.sender }}</span>
                      <span class="ml-2 grey--text" style="font-size: 11px">{{ message.time }}</span>
                    </div>
                    <v-card class="pa-3 message-received" flat>
                      <span style="font-size: 14px; line-height: 1.4">{{ message.text }}</span>
                    </v-card>
                  </div>
                </div>

                <!-- Sent Message -->
                <div v-else class="d-flex align-start flex-row-reverse">
                  <v-avatar size="32" class="ml-2 mt-1">
                    <img :src="message.avatar" alt="me" />
                  </v-avatar>
                  <div style="max-width: 75%" class="d-flex flex-column align-end">
                    <div class="d-flex align-end mb-1">
                      <span class="mr-2 grey--text" style="font-size: 11px">{{ message.time }}</span>
                      <span class="font-weight-bold" style="font-size: 13px; color: #333">{{ message.sender }}</span>
                    </div>
                    <v-card class="pa-3 message-sent" color="#f69227" dark flat>
                      <span style="font-size: 14px; line-height: 1.4">{{ message.text }}</span>
                    </v-card>
                  </div>
                </div>
              </div>
            </div>

            <!-- Chat Input -->
            <div class="pa-3 bg-light flex-shrink-0">
              <v-text-field
                v-model="msg"
                placeholder="Type a message..."
                outlined
                dense
                rounded
                hide-details
                color="#f69227"
                class="chat-input-field"
                @keyup.enter="sendMessage"
              >
                <template v-slot:prepend-inner>
                  <v-btn icon small class="mt-n1"><v-icon color="grey">mdi-emoticon-outline</v-icon></v-btn>
                </template>
                <template v-slot:append>
                  <v-btn icon small class="mt-n1 mr-1"><v-icon color="grey">mdi-paperclip</v-icon></v-btn>
                  <v-btn icon small class="mt-n1 mr-1"><v-icon color="grey">mdi-camera-outline</v-icon></v-btn>
                  <v-btn icon small color="#f69227" class="mt-n1" @click="sendMessage"><v-icon>mdi-send</v-icon></v-btn>
                </template>
              </v-text-field>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    activeChat: 1,
    msg: "",
    chats: [
      {
        id: 1,
        title: "Ahmadu Bello University",
        subtitle: "Accounting 2020",
        avatar: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=100&h=100&fit=crop",
        unread: 3
      },
      {
        id: 2,
        title: "JAMB Math Prep",
        subtitle: "Who solved question 4?",
        avatar: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=100&h=100&fit=crop",
        unread: 0
      },
      {
        id: 3,
        title: "Computer Science Study",
        subtitle: "Let's review algorithms",
        avatar: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=100&h=100&fit=crop",
        unread: 5
      },
      {
        id: 4,
        title: "WAEC Physics Revision",
        subtitle: "Thanks for the notes",
        avatar: "https://images.unsplash.com/photo-1636466497217-26a8cbeaf0aa?w=100&h=100&fit=crop",
        unread: 0
      },
      {
        id: 5,
        title: "Study Group Alpha",
        subtitle: "Meeting at 5PM",
        avatar: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=100&h=100&fit=crop",
        unread: 1
      },
    ]
  }),
  computed: {
    activeChatData() {
      return this.chats.find(c => c.id === this.activeChat) || this.chats[0];
    },
    messages() {
      return this.$root.storeState.groupChats;
    }
  },
  methods: {
    group() {
      this.$router.push("/group");
    },
    sendMessage() {
      if (this.msg.trim() === "") return;
      
      const now = new Date();
      let hours = now.getHours();
      let minutes = now.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; 
      minutes = minutes < 10 ? '0' + minutes : minutes;
      const strTime = hours + ':' + minutes + ' ' + ampm;

      this.$root.store.addChatMessage({
        isMe: true,
        sender: this.$root.storeState.currentUser.name || 'You',
        avatar: this.$root.store.getUserAvatar(),
        time: strTime,
        text: this.msg
      });
      
      this.msg = "";
      
      // Scroll to bottom
      this.$nextTick(() => {
        const container = document.getElementById('chat-container');
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      const container = document.getElementById('chat-container');
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    });
  }
};
</script>

<style scoped>
.custom__bg {
  background: #f5f5f5;
}
.bg-light {
  background-color: #fafbfc !important;
}
.bg-transparent {
  background-color: transparent !important;
}
.custom__overflow {
  overflow-y: auto;
  overflow-x: hidden;
}
.custom__chat_area {
  background: url("https://www.transparenttextures.com/patterns/cubes.png") #f0f2f5;
}

.message-received {
  border-radius: 0 12px 12px 12px !important;
  background-color: white !important;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1) !important;
}

.message-sent {
  border-radius: 12px 0 12px 12px !important;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1) !important;
}

/* Customize Vuetify text field for chat */
.chat-input-field ::v-deep .v-input__slot {
  background-color: white !important;
}
</style>
